<template>
  <v-dialog v-model="displayDialog" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" v-bind="attrs" v-on="on">
        How to use the Tracking Portal
        <v-icon right> mdi-help-circle-outline </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="primary--text"
        >How to use the Tracking Portal</v-card-title
      >
      <v-divider></v-divider>
      <v-card-text class="mt-5 body-1">
        <p>
          1. Please ensure that you are tracking your shipment from the vendors
          you purchase from, to determine how many packages you expect to
          receive.
        </p>

        <p>
          2. Ensure that all your packages are listed on our tracking portal. Do
          not rely on notifications that you receive from the vendor alone.
        </p>

        <p>
          3. If you don't see a package listed within 48 hours after you have
          been notified it as delivered. Please contact us with the tracking
          number in dispute.
        </p>

        <p>
          4. We will not ship your package until you upload your invoice(s) and
          click “Proceed to Ship”.
        </p>

        <p>
          5. If you are planning on consolidating your shipment, only click
          “Proceed to Ship” once all of your packages are reflected on our
          tracking portal.
        </p>

        <p>
          6. We primary ship by Ocean and our cut off time is every Thursday at
          5pm. Please ensure to upload your invoice(s) and click “Proceed to
          Ship” before the deadline.
        </p>

				<p>
					7. For air freight services, our cut off time is every Monday at 5pm. 
					Please ensure to upload your invoice(s) and click "Proceed to Ship" before the deadline.
				</p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" text @click="displayDialog = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GuideDialog',

  data: () => ({
    displayDialog: false,
  }),

};
</script>
<style lang="scss" scoped>
</style>
